import { Navigate } from "react-router";
import { getAuthenticated } from "./config/FunctionHelper";
import { paths } from "./config/TextMessage";

const ProtectedRouteV2 = ({ children }) => {
    const isAuthenticated: any = getAuthenticated();

    return isAuthenticated === 'true' ? <>{children}</> : <Navigate to={paths?.signin} />
    
}

export default ProtectedRouteV2